import styled from 'styled-components';

export const StyledLoadingSkeletonWrapper = styled.div`
  display: grid;
  place-items: center;
  & * {
    width: 100% !important;
    height: 100% !important;
  }
  margin: 0 auto;
  height: 100vh;
`;
